import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Div, DefaultTheme } from '@pinpoint/design-kit';

const StyledInput = styled.input`
  appearance: none;
  width: ${(props) => props.w};
  height: ${(props) => props.h};
  background: ${(props) =>
    props.disabled
      ? DefaultTheme.colors[props.disabledBg] || props.disabledBg
      : DefaultTheme.colors[props.bg] || props.bg};
  outline: none;
  opacity: ${(props) => props.opacity};
  transition: ${(props) => props.transition};
  border-radius: 4px;

  &:hover {
    opacity: ${(props) => (props.disabled ? props.opacity : props.hoverOpacity)};
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: ${(props) => props.thumbW};
    height: ${(props) => props.thumbH};
    background: ${(props) =>
      props.disabled
        ? DefaultTheme.colors[props.disabledThumbBg] || props.disabledThumbBg
        : DefaultTheme.colors[props.thumbBg] || props.thumbBg};
    border-radius: 50%;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'cursor')};
  }

  &::-moz-range-thumb {
    appearance: none;
    width: ${(props) => props.thumbW};
    height: ${(props) => props.thumbH};
    background: ${(props) =>
      props.disabled
        ? DefaultTheme.colors[props.disabledThumbBg] || props.disabledThumbBg
        : DefaultTheme.colors[props.thumbBg] || props.thumbBg};
    border-radius: 50%;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'cursor')};
  }
`;

/* eslint-disable react/default-props-match-prop-types */

function Slider({ min, max, value, onChange, ...rest }) {
  return (
    <Div w="100%">
      <StyledInput
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => {
          onChange(e);
        }}
        {...rest}
      />
    </Div>
  );
}

Slider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

Slider.defaultProps = {
  min: 1,
  max: 100,
  value: 50,
  onChange: () => null,
  w: '100%',
  h: '1.25rem',
  bg: 'gray500',
  opacity: '0.7',
  hoverOpacity: '1',
  transition: 'opacity .2s',
  thumbW: '1.25rem',
  thumbH: '1.25rem',
  thumbBg: 'blue',
  disabledBg: 'gray300',
  disabledThumbBg: 'gray700',
  disabled: false,
};

export default Slider;
